import {
  uploadBytes as firebaseUploadBytes,
  uploadBytesResumable as firebaseUploadBytesResumable,
} from 'firebase/storage';
import { assertViewerCanWrite } from './viewerOnly';

export const uploadBytes: typeof firebaseUploadBytes = ((...args: Parameters<typeof firebaseUploadBytes>) => {
  assertViewerCanWrite();
  return firebaseUploadBytes(...args);
}) as typeof firebaseUploadBytes;

export const uploadBytesResumable: typeof firebaseUploadBytesResumable = ((...args: Parameters<typeof firebaseUploadBytesResumable>) => {
  assertViewerCanWrite();
  return firebaseUploadBytesResumable(...args);
}) as typeof firebaseUploadBytesResumable;
